import React, { useEffect, useState } from 'react';
import { Card, Descriptions, Row, Col, Divider, Typography } from 'antd';
import {
  UserOutlined,
  HomeOutlined,
  DollarOutlined,
  BuildOutlined,
} from '@ant-design/icons';
import { useGetPurchaseApplicationSummaryQuery } from '@/pages/mortgage/apis/purchaseAPI';
import { useLocation, useParams } from 'react-router-dom';
import {
  mapCamelCaseToSpaceCase,
  mapSnakeCaseToSpaceCase,
} from '@/utils/mapper';
const formatMoney = (value: number) => `$${value.toLocaleString()}`;

const formatNumber = (value: number) => value.toLocaleString();

const ApplicationView: React.FC<{ data: any; isLoading: boolean }> = ({
  data,
  isLoading,
}) => {
  const [userData, setUserData] = useState<any>(null);
  const [primaryDetails, setPrimaryDetails] = useState<any>(null);
  const [incomeDetails, setIncomeDetails] = useState<any>(null);
  const [propertyData, setPropertyData] = useState<any>(null);

  console.log('data', data);

  useEffect(() => {
    if (data) {
      if (data?.data?.user_data) {
        setUserData(data?.data?.user_data);
      }
      if (data?.data?.primary_detail) {
        setPrimaryDetails(data?.data?.primary_detail);
      }
      if (data?.data?.income_detail) {
        setIncomeDetails(data?.data?.income_detail);
      }
      if (data?.data?.properties) {
        setPropertyData(data?.data?.properties);
      }
    }
  }, [data]);

  return (
    <div style={{ padding: '12px 0' }}>
      <Card
        loading={isLoading}
        title={
          <Typography.Title
            level={4}
            style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}
          >
            <UserOutlined style={{ fontSize: 18 }} /> Applicant Information
          </Typography.Title>
        }
        style={{ marginBottom: 24 }}
      >
        <Descriptions
          column={2}
          layout="vertical"
          colon={false}
          labelStyle={{
            fontWeight: 500,
            fontSize: 14,
            margin: 0,
            paddingBottom: 0,
          }}
          contentStyle={{ fontSize: 16, fontWeight: 600 }}
        >
          <Descriptions.Item label="Full Name">
            {userData?.first_name} {userData?.last_name}
          </Descriptions.Item>
          <Descriptions.Item label="Email">{userData?.email}</Descriptions.Item>
          <Descriptions.Item label="Phone">{userData?.phone}</Descriptions.Item>
        </Descriptions>
      </Card>

      <Card
        loading={isLoading}
        title={
          <Typography.Title
            level={4}
            style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}
          >
            <HomeOutlined style={{ fontSize: 18 }} /> Primary Details
          </Typography.Title>
        }
        style={{ marginBottom: 24 }}
      >
        <Descriptions
          column={2}
          layout="vertical"
          colon={false}
          labelStyle={{
            fontWeight: 500,
            fontSize: 14,
            margin: 0,
            paddingBottom: 0,
          }}
          contentStyle={{ fontSize: 16, fontWeight: 600 }}
        >
          {Object.entries(primaryDetails || {}).map(([key, value]) => {
            if (
              typeof value !== 'object' &&
              value !== null &&
              value !== undefined &&
              value !== ''
            ) {
              return (
                <Descriptions.Item
                  key={key}
                  label={mapSnakeCaseToSpaceCase(key)}
                >
                  {typeof value === 'number'
                    ? formatNumber(value)
                    : mapSnakeCaseToSpaceCase(String(value))}
                </Descriptions.Item>
              );
            }
          })}
        </Descriptions>
      </Card>

      <Card
        loading={isLoading}
        title={
          <Typography.Title
            level={4}
            style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}
          >
            <DollarOutlined style={{ fontSize: 18 }} /> Income & Employment
            Details
          </Typography.Title>
        }
        style={{ marginBottom: 24 }}
      >
        <Descriptions
          column={2}
          layout="vertical"
          colon={false}
          labelStyle={{
            fontWeight: 500,
            fontSize: 14,
            margin: 0,
            paddingBottom: 0,
          }}
          contentStyle={{ fontSize: 16, fontWeight: 600 }}
        >
          {Object.entries(incomeDetails || {}).map(([key, value]) => {
            if (
              typeof value !== 'object' &&
              value !== null &&
              value !== undefined &&
              value !== ''
            ) {
              return (
                <Descriptions.Item
                  key={key}
                  label={mapSnakeCaseToSpaceCase(key)}
                >
                  {typeof value === 'number'
                    ? formatNumber(value)
                    : mapSnakeCaseToSpaceCase(String(value))}
                </Descriptions.Item>
              );
            }
          })}
        </Descriptions>
      </Card>

      <Card
        title={
          <Typography.Title
            level={4}
            style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}
          >
            <BuildOutlined style={{ fontSize: 18 }} /> Property Details
          </Typography.Title>
        }
      >
        {propertyData?.map((property: any, index: number) => {
          const propertyDetails = property?.property_details;

          // Filter and format valid entries
          const items = Object.entries(propertyDetails || {}).filter(
            ([_, value]) =>
              typeof value !== 'object' &&
              value !== null &&
              value !== undefined &&
              value !== '',
          );

          if (items.length === 0) return null;

          return (
            <Card
              key={index}
              loading={isLoading}
              title={`${propertyDetails?.property_address} ${
                property?.property_location
                  ? `\t(${property?.property_location.toUpperCase()})\t `
                  : ''
              }`}
              style={{ marginBottom: 24 }}
            >
              <Descriptions
                column={2}
                layout="vertical"
                colon={false}
                labelStyle={{
                  fontWeight: 500,
                  fontSize: 14,
                  margin: 0,
                  paddingBottom: 0,
                }}
                contentStyle={{ fontSize: 16, fontWeight: 600 }}
              >
                {items.map(([key, value]) => (
                  <Descriptions.Item
                    key={key}
                    label={mapSnakeCaseToSpaceCase(key)}
                  >
                    {typeof value === 'number'
                      ? formatNumber(value)
                      : mapSnakeCaseToSpaceCase(String(value))}
                  </Descriptions.Item>
                ))}
              </Descriptions>
            </Card>
          );
        })}
      </Card>
    </div>
  );
};

export default ApplicationView;
